import { LoadedQuotation, WizardSavedPassenger, buildPassengerSlots, getRoomBaseConfigFromQuotation } from '../types';
import { getPassengerIdsByKind } from '../mappers/quotationServiceMappers';

export type FlightPassengerCounts = {
	adult: number;
	child: number;
	infant: number;
};

export const getFlightPassengerCounts = (
	quotation: LoadedQuotation,
	savedPassengers: WizardSavedPassenger[],
): FlightPassengerCounts => {
	const slots = buildPassengerSlots(getRoomBaseConfigFromQuotation(quotation));
	return {
		adult: getPassengerIdsByKind(savedPassengers, slots, 'adult').length,
		child: getPassengerIdsByKind(savedPassengers, slots, 'child').length,
		infant: getPassengerIdsByKind(savedPassengers, slots, 'infant').length,
	};
};
